import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

import { useNow } from '@/hooks/useNow'
import { formatCountdown } from '../maintenanceTimeline'
import { MUTED_TEXT_CLASS_NAME } from './styles'

const COUNTDOWN_TICK_MS = 1000

type WindowCountdownProps = {
  endsAt: string
}

export const WindowCountdown = memo(function WindowCountdown({
  endsAt,
}: WindowCountdownProps) {
  const { t } = useTranslation()
  const now = useNow(COUNTDOWN_TICK_MS)

  return (
    <div data-testid="maintenance-window-countdown" className="text-right">
      <p className={clsx('text-xs', MUTED_TEXT_CLASS_NAME)}>
        {t('maintenance.window.endsIn')}
      </p>
      <p className="text-2xl font-semibold tabular-nums text-gravel dark:text-snow">
        {formatCountdown({ until: endsAt, now })}
      </p>
    </div>
  )
})
